export const allinCancelFunc = (button) => {
    let $button = $(button);
    let $bet_wrap = $button.closest('.bet-content');
    $bet_wrap.find('.pay__item:visible').click();
};